export default {
  widgets: {
    pilotOffers: "Pilotenangebote",
    auctions: "Börse",
    departmentList: "Meine Abteilungen",
    warehouseList: "Meine Lagerhäuser",
    documentList: "Meine Dokumente",
    leasingList: "Leasing",
    driverList: "Fahrer",
    workerList: "Mitarbeiter",
    groupList: "Meine Gruppen",
    monitoryArchive: "Avisierungsarchiv",
    companyData: "Firma",
    outsideWarehouse: "Externe Lagerhäuser",
    auctionParticipants: "Teilnehmer der Anzeige",
    auctionArchive: "Anzeige-Archiv",
    walletTimeWindows: "Zeitfenster",
    walletSub: "Abonnement",
    invoicesList: "Rechnungen",
    factoring: "Factoring",
    transports: "Transporte",
    surcharges: "Zuschläge",
    currentAuctionsAvailable: "Aufträge",
  },
};
